import { apiPost, notifySuccess } from "@redriver/cinnamon";

const ActionTypes = {
  SendToFunder: "SHEETS/SEND_TO_FUNDER",
};

export const sendToFunder = ({ sheetId }) =>
  apiPost(ActionTypes.SendToFunder, `sheets/${sheetId}/send-to-funder`);
